import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BilletRoutingModule } from './billet-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';
import { ComponentsModule } from 'src/app/components/components.module';
import { MyMissingTranslationHandler } from 'src/app/core/_config/missingTranslationHandler';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';
import { DueDateInBatchesComponent } from './components/due-date-in-batches/due-date-in-batches.component';

let materialModules = [
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatDialogModule,
    MatMenuModule
];

@NgModule({
    declarations: [DueDateInBatchesComponent],
    imports: [
        materialModules,
        CommonModule,
        BilletRoutingModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(),
        NgxCurrencyModule,
        TranslateModule.forChild({
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            useDefaultLang: false,
        }),
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { floatLabel: 'always' },
        },
    ],
    entryComponents: [YesOrNoComponent],
})
export class BilletModule {}
